import React from "react";
import {
  Layout, Menu,FloatButton, Avatar, Tooltip, Button, Affix, Space, Dropdown, message} from "antd";
import { Route, Switch, Link, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import RouteFields from "Routes/RouteFields";
import utils from "utils";
import api from "../utils/api";
import {
  LoggedUserRoutes,  DoctorRoutes, GuestUserRoutes, CareAdminRoutes,
  SubscriptionPlanRoutes, SuperAdminRoutes, CorperateAdminRoutes,
  CareAdminDomainRoutes,SettingsRoutesCase1,SettingsRoutesCase2,SettingsDoctorRoutes,LogoutRoutes,
  ROLE_ROUTES, 
  DoctorRoutesBase,
  CareAdminRoutesBase,
  SuperAdminRoutesBase} from "../Routes/Route";
import "antd/dist/reset.css";
import PageNotFound from "Pages/NotFound/NotFound";
import Loader from "Components/Loader";
import CareChatWidget from "Pages/Chat/CareChatWidget";
import icons from "Common/Icons";
import Swal from "sweetalert2";
import "./Layout.scss";
import { breadCrumbroutesDelete} from "store/slice/breadcrumb-slice";
import { recentRoutes , upComingPath } from "store/slice/login-slice";
import { setNetworkDrop } from "store/slice/login-slice";
import { setLanguage } from "store/slice/login-slice";
import { removeFilteredValue } from "store/slice/ticketlistFilter-slice";
import {removeFilteredCouponValue} from "store/slice/couponslistFilter-slice";
import { setCollapse, setLabelColorTheme } from "store/slice/dashboard-slice";
import { ONLINE_MSG, OFFLINE_MSG, GUEST_ROUTES, PUBLIC_ROUTES } from "Common/constant";
import {  CopyrightOutlined, UserOutlined } from '@ant-design/icons';
import { withTranslation } from "react-i18next";
import { PRIMARY_LANG, ORG_ID, FONT_FAMILY} from "Common/constant";
import Heading from "Components/Heading";
import PatientChatWidgetNewVersion from "Pages/Chat/PatientChatWidgetNewVersion";
import { resetFunnelingData } from "store/slice/assessment-slice";
import { CONSTANTS } from "utils/constant";
import { LogoutOutlinedMenu } from "Common/ReactIcons";
import UrlHistoryList from "Components/UrlHistoryList";

const { SubMenu } = Menu;
const { Content, Sider, Footer, Header } = Layout;
class MainLayout extends React.Component {
  _routesPath = [];
  constructor(props) {
    super(props);

    let pathname = window.location.pathname.split("/");
    let { user_details, account_details } = this.props || {};
    this.state = {
      role: user_details?.role || "guest",
      name: user_details?.name,
      baseUrl: user_details?.baseUrl || "guest-user",
      user_details: user_details,
      account_details: account_details,
      selectedPath: pathname[pathname.length - 1],
      routes: [],
      windowResize: window?.innerWidth,
      collapse: false,
      crumbUpdate: true,
      previousPath: this.props.previousPath,
      showNetworkBar: false,
      isOfflineNav: false,
      openKeys:[],
      rootSubmenuKeys:[],
      isLiveChatOpen: false,
      isAiBotChatOpen : false,
      chatDetails: null,
      ai_support:false,
      color_theme : true,
      organisation_mini_logo : "",
      organisation_company_logo : "",
      organisation_id : "",
      label_color_theme :"",
      toolTipEnabled : true,
      TooltipOpen:false,
    };
  }

  getRoutes() {
    let { role, baseUrl, routes, user_details } = this.state;
    let carepath=["all_tickets","patients","clinicians","medicines","offline_registration","consultations","billing","vendor","coupons"];
    let superpath=["user_management"];
    let doctorpath=["my_appointments","my_patients"];
    // [...carepath,...superpath,...doctorpath]
    const page_access=user_details?.page_access||{};
    let allowed_path= Object.keys(page_access).filter(key => page_access[key] === true);
    if(this.props.isRoleSelected) {
    let subscription =
      localStorage.getItem("subscription") === null || undefined
        ? {}
        : JSON.parse(localStorage.getItem("subscription"));
    let {
      is_membership_active,
      membership_type,
      is_membership_expired,
      membership_expiry_date,
      is_evaluated,
    } = subscription || {};
    if (role == "patient") {
      let pathname = location.pathname.split("/");
      let tempRoutes =  user_details.account_is_active && user_details.is_terms_and_privacy && (this.props.up_coming_path == "dashboard" || pathname[pathname.length - 1] == "dashboard" || pathname[pathname.length - 1] == "consultation-history" || pathname[pathname.length - 1] == "assessment-history" || pathname[pathname.length - 1] == "health-profile" || pathname[pathname.length - 1] == "select-assessment" || pathname[pathname.length - 1] == "schedule-appointment" || pathname[pathname.length - 1] == "emotion" || pathname[pathname.length - 1] == "stress" || pathname[pathname.length - 1] == "geriatric") && pathname[pathname.length - 1] != 'profile-lists' ? [...LoggedUserRoutes] : [];
      if ((is_membership_expired || (membership_type) || !is_membership_active || !membership_expiry_date || is_evaluated) && (user_details?.org_type == "individual" || user_details?.org_type == "corporate") && user_details.account_is_active && pathname[pathname.length - 1] != 'profile-lists' && pathname[pathname.length - 1] != 'login' && user_details.is_terms_and_privacy) 
        tempRoutes = [...tempRoutes, ...SubscriptionPlanRoutes];
      // tempRoutes  = [...tempRoutes, ...ProfileListRoutes];
        //  tempRoutes = tempRoutes.splice(tempRoutes.length-1,0,...SubscriptionPlanRoutes)
      if(tempRoutes.length > 0 ){
        this.props.upComingPath("dashboard");
      }
      let settingsFlag = true;
      let settingsSwitchFlag = true;
      if(tempRoutes.length > 0 && (this.state.account_details?.user_id != this.state.user_details?.user_id )){
        tempRoutes.push(...SettingsRoutesCase2)
        settingsSwitchFlag =false;
      }
      if((this.state.selectedPath == 'my-account' || location.pathname == '/logged-in-user/profile-lists') && !this.state.user_details?.is_primary){
        settingsFlag = false;
        tempRoutes = [...SettingsRoutesCase1]
      }
      if(((this.state.account_details?.user_id == this.state.user_details?.user_id ) || this.state.selectedPath == 'my-account' || this.state.selectedPath == 'profile-lists') && settingsFlag && settingsSwitchFlag)
        tempRoutes.push(...SettingsRoutesCase1)
      routes = tempRoutes;
      baseUrl = "/logged-in-user";
    } else if (role == "doctor") {      
      let FilteredDoctorRoutes=utils.allowedRoute(allowed_path,DoctorRoutesBase);
      routes = [...DoctorRoutes,...FilteredDoctorRoutes, ...SettingsDoctorRoutes];
      baseUrl = "/doctor";
    } else if (role == "care-admin") {
      let careRoutes = {
        0: ["care-admin-domain"],
        1: [
          "care-admin-domain",
          "dashboard",
          "select-tickets",
          "tickets-list",
          "search-patient",
          "add-medicine",
          "consultation-list",
          "doctor-availabilty",
          "org-records",
          "patient-lists",
          "plan-history",
          "patient-plan",
          "my-tickets",
          "manage-coupon",
          "patient-records",
          "patient-consultation",
          "analytics",
          "offline-patient-register",
          "new-user","vital-form","billing","edit-bill","search-vendor"
        ],
        2: ["care-admin-domain", "chat"],
      };
      let key = this.props.selected_care_admin_domain || "all";      
      let FilteredCareAdminRoutes=utils.allowedRoute(allowed_path,CareAdminRoutesBase);
      let tempRoutes = [...CareAdminRoutes,...FilteredCareAdminRoutes,];
      let finalRoutes = tempRoutes.filter((m) => {
        let tempString = m.path.replace("/", "");
        if (key == "all") return false;
        else if (careRoutes[key]?.includes(tempString)) return true;
        else return false;
      });
      if (key == "all") finalRoutes  = [...CareAdminDomainRoutes];
      routes = [...finalRoutes];
      if(this.props.location.pathname == "/care-admin/care-admin-domain")  routes = [...CareAdminDomainRoutes];
      baseUrl = "/care-admin";
    } else if (role == "super_admin") {      
      let FilteredSuperAdminRoutes=utils.allowedRoute(allowed_path,SuperAdminRoutesBase);
      routes = [...SuperAdminRoutes,...FilteredSuperAdminRoutes,];
      baseUrl = "/super-admin";
    } else if (role == "client-admin") {
      routes = [...CorperateAdminRoutes];
      baseUrl = "/corporate-admin";
    } else {
      routes = GuestUserRoutes;
      baseUrl = "/guest-user";
    }
    if(this.props.isMultipleRolePresent)
      routes = [...routes, ...ROLE_ROUTES]
    return { routes, baseUrl };
  } else {
    if(this.state.role == "role") {
    baseUrl = "/role-types";
    routes = ROLE_ROUTES;
    return { routes, baseUrl };
    } else {
    routes = GuestUserRoutes;
    baseUrl = "/guest-user";
    return { routes, baseUrl };
    }
  }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      (prevState.showNetworkBar && prevState.isOfflineNav) ||
      (nextProps.networkError && !navigator.onLine)
    ) {
      throw new Error("Network Error");
    }

    if (nextProps.user_details !== prevState.user_details) {
      let { user_details, account_details } = nextProps || {};
      return {
        user_details: user_details,
        account_details: account_details,
        role: user_details?.role || "guest",
        name: user_details?.name,
        baseUrl: user_details?.baseUrl,
      };
    } else return null;
  }

  validateLangRetainment() {
    if (
      this.props.user_details.language &&
      this.props.i18n.language != this.props.user_details.language
    ) {
      this.props.i18n.changeLanguage(this.props.user_details.language);
      if (this.props.user_details.language != PRIMARY_LANG) {
        this.props.setLanguage({
          language: this.props.user_details.language,
          includePrimeLang: true,
        });
      }
    }
  }

  setSelectedMenuItem() {
    let pathname = location.pathname.split("/");
    // let flag = this.state.routes.findIndex(obj => {
    //   if (obj.hasOwnProperty("children")) {
    //     return obj.children.findIndex(m => m.path.indexOf(pathname) != -1)
    //   }
    //   return false;

    // });
    let flag = false;
    let routeValue = "";
    let { routes } = this.getRoutes();
    (routes || []).forEach((route, index) => {
      if (!route.children) {
        if (route?.value == pathname[pathname.length - 1]) {
          flag = true;
          routeValue = route?.selectedMenu || pathname[pathname.length - 1];
        }
      } else {
        route.children.forEach((childRoute) => {
          if (childRoute?.value == pathname[pathname.length - 1]) {
            flag = true;
            routeValue = childRoute?.value || "";
          }
        });
      }
    });
    if (!flag) {
      this.setState(
        (prevState) => ({
          selectedPath: prevState.selectedPath,
        }),
        () => {
          this.props.recentRoute(this.state.selectedPath);
        }
      );
    } else {
      this.setState(
        {
          selectedPath: routeValue,
        },
        () => {
          this.props.recentRoute(this.state.selectedPath);
        }
      );
    }
    // if(flag){
    //   this.setState({
    //     selectedPath: pathname[pathname.length - 1],
    //   })
    // }
  }

  handleCareViewMessage(selectedPatient) {
    this.setState({
      selectedPatient: selectedPatient,
    });
  }

  prepareRoutes() {
    let menus = [];
    let childrenSupportedKeys = [];
    let { baseUrl, routes } = this.getRoutes();

    (routes || []).forEach((route, index) => {      
      let disable = this.props.location.pathname.includes("video-consultation") ? true : false;
      if (route.showmenu) {
        if (!route.children) {
          menus.push({
            ...route,
            key: route?.value || "",
            label: disable ? this.props.t(route?.label, { lng: PRIMARY_LANG }) : <Link to={`${baseUrl}${route.path}`}>{this.props.t(route?.label, { lng: PRIMARY_LANG })}</Link>,
            theme: "dark",
            showmenu: "",
            style: { paddding: 0 },
            // theme:"dark",
            showmenu: "",
            disabled: disable,
          });
          childrenSupportedKeys.push(route.value)
        } else {
          let newChildren = route.children.map((subItem, j) => {
            return {
              ...subItem,
              key:subItem.value,
              style:{ paddding:0},
              theme:"dark",
              label: disable ? <>{this.props.t(subItem?.label, { lng: PRIMARY_LANG })}</> : subItem.value == "logout" ? <a onClick={e=>e.preventDefault()}>{this.props.t(subItem?.label, { lng: PRIMARY_LANG })}</a> : <Link to={`${baseUrl}${subItem.path}`}>{this.props.t(subItem?.label, { lng: PRIMARY_LANG })}</Link>,
              disabled:disable,
            }})
          menus.push(
              {
                ...route,
                key:route.value,
                children: newChildren,
                showmenu:"",
                style:{ paddding:0},
                theme:"dark",
                disabled:disable,
              }
            )
            childrenSupportedKeys.push(route.value)
        }        
    }
    }) 
    this.rootSubmenuKeys = childrenSupportedKeys ;
    // console.log(childrenSupportedKeys)
    return menus;
  }

  checkAndStoreDeepLink() {
    let pathname = window.location.pathname.split("/");
    // if (
    //   this.state.user_details?.role == "Guest" &&
    //   !PUBLIC_ROUTES.includes(pathname[pathname.length - 1])
    // ) {
    if (
      this.state.user_details?.role == "Guest" &&
      !PUBLIC_ROUTES.includes(window.location.pathname)
    ) {
      //sessionStorage.setItem("deepLinkUrl", pathname[pathname.length - 1]);
      // sessionStorage.setItem("deepLinkUrl", window.location.pathname);
    }
  }

  prepareRoutesView(routes) {
    this.checkAndStoreDeepLink();
    let { baseUrl } = this.getRoutes();
    (routes || []).forEach((route, index) => {
      if (
        route.path &&
        route.component &&
        (utils.IsClassComponent(route.component) ||
          utils.IsFunctionalComponent(route.component))
      ) {
        this._routesPath.push(
          <Route
            path={`${baseUrl}${route.path}`}
            key={`${baseUrl}${route.path}-${index}`}
          >
            <route.component />
          </Route>
        );
      } else if (
        route.path &&
        route.render &&
        typeof route.render == "function"
      ) {
        this._routesPath.push(
          <Route
            path={`${baseUrl}${route.path}`}
            render={(props) => route.render(props)}
            key={`${baseUrl}${route.path}-${index}`}
          ></Route>
        );
      } else if (
        route.path &&
        route.component &&
        React.isValidElement(route.component)
      ) {
        this._routesPath.push(
          <Route
            path={`${baseUrl}${route.path}`}
            key={`${baseUrl}${route.path}-${index}`}
          >
            {route.component}
          </Route>
        );
      } else if (route.path && route.component === null) {
        this._routesPath.push(
          <Route
            path={`${baseUrl}${route.path}`}
            key={`${baseUrl}${route.path}-${index}`}
          >
            <div>{route.label}</div>
          </Route>
        );
      }

      if (route.hasOwnProperty("children")) {
        this.prepareRoutesView(route.children);
      }
    });
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (this.state.selectedPath !== "video-consultation" && this.props.previousPath !== nextProps.previousPath) {
  //     return true
  //   }
  //   if (this.props.previousPath != []) {
  //     return true
  //   }

  // }

  getSidebarStatus() {
    let show = "show";
    if (
      Object.keys(this.state.user_details || {}).length &&
      this.state.role &&
      this.state.role == "Guest" &&
      this.state.baseUrl == "/guest-user"
    ) {
      show = "hide";
    } else if (
      Object.keys(this.state.user_details || {}).length &&
      this.state.role &&
      this.state.role == "care-admin" &&
      this.state.selectedPath == "care-admin-domain"
    ) {
      show = "hide";
    } else if (this.state.user_details == undefined) {
      show = "hide";
    } else if (this.state.selectedPath == "care-admin-domain") {
      show = "hide";
    }

    return show;
  }
  handleResize = () => {
    // this.setState({ windowResize: window.innerWidth + 0 });
  };

  handleOnline() {
    this.setState({ isOnline: true });
    setTimeout(() => {
      this.setState({ showNetworkBar: false });
    }, 3000);
  }

  componentDidUpdate(prevProps) {
    if(this.state.color_theme || this.state.organisation_id != (this.props?.user_details?.org_name || (this.state.user_details?.role == "Guest" && window.location.host) || "default"))
      this.colorCodeCapture();
    this.fontFamilyCapture();
    this.validateLangRetainment();
    if (this.props.location !== prevProps.location) {
      this.setSelectedMenuItem();
    }
    return;
  }
  fontFamilyCapture(){    
    // let user_role = this.props?.user_details?.role;
    var root = document.documentElement;
    // if(user_role == "doctor" || user_role == "care-admin"){
      root?.style.setProperty("--font-family", "var(--jost-font-family)");
    // }
    // else{
      // root?.style.setProperty("--font-family", "var(--inter-font-family)");
    // }
  }
  handleOffline() {
    this.setState({ isOnline: false, showNetworkBar: true });
  }

  redirectToLogin() {
    this.props.resetFunnelingData();
    this.props.history.replace({
      pathname: "/guest-user/login",
    });
  }
  onOpenChange(keyVal){
    let keys = keyVal?.key ? keyVal.keyPath : keyVal ;
    const latestOpenKey = keys.find((key) => this.state.openKeys.indexOf(key) === -1);
    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({openKeys : keys});      
    } else {
      let keysVal = latestOpenKey ? [latestOpenKey] : []
      this.setState({openKeys : keysVal });
    }
  }

  clearChatDetails() {    
    this.setState({ isLiveChatOpen: false, chatDetails: null });
  }

  clearAiBotChatDetails() {
    this.setState({ isAiBotChatOpen: false });
  }

  colorCodeCapture=()=>{
    let org_id = this.props?.user_details?.org_name || (this.state.user_details?.role == "Guest" && window.location.host) || "default";
    let colorCode=ORG_ID[org_id] ? ORG_ID[org_id] : ORG_ID["default"];
    var root = document.documentElement;
    root?.style.setProperty(
        "--background-color", colorCode?.color,
    );
    root?.style.setProperty(
        "--teal-50", colorCode?.teal_50,
    );
    root?.style.setProperty(
        "--teal-100", colorCode?.teal_100,
    );
    root?.style.setProperty(
      "--teal-300", colorCode?.teal_300,
    );
    root?.style.setProperty(
      "--teal-400", colorCode?.teal_400,
    );
    root?.style.setProperty(
      "--teal-500", colorCode?.teal_500,
    );
    root?.style.setProperty(
      "--teal-600", colorCode?.teal_600,
    );
    root?.style.setProperty(
      "--teal-700", colorCode?.teal_700,
    );
    root?.style.setProperty(
      "--teal-800", colorCode?.teal_800,
    );
    root?.style.setProperty(
      "--teal-900", colorCode?.teal_900,
    );
    root?.style.setProperty(
      "--green-100", colorCode?.green_100,
    );
    root?.style.setProperty(
      "--icon-filter", colorCode?.dashbord_tick_icon,
    );
    root?.style.setProperty(
      "--menu-icon-filter", colorCode?.menu_icon,
    );
    this.setState({color_theme : false, organisation_id: org_id, organisation_mini_logo: colorCode?.mini_logo, organisation_company_logo: colorCode?.full_logo, label_color_theme: colorCode?.label})
    this.props.setLabelValue(colorCode?.label)
  }

  componentDidMount() {
    this.colorCodeCapture();
    if (this.state.user_details?.role == "patient") {
      api.get_patient_chat_status().then((res) => {
        if(res?.data?.status ==200 ){
        let data = res.data?.data ? res.data.data :  {}
        if (data?.patient_token) {
          this.setState({
            isLiveChatOpen: true,
            openPatientChat: true,
            chatDetails: data,
          });
        } else {
          if (this.props.retainedAiBotChatDetails?.aiBotChatId) {
            this.setState({ isAiBotChatOpen : true, openPatientChat: true });
          }
        }}
      });
    }
    if (!navigator.onLine) {
      throw new Error("Network Error");
    }
    if (navigator.onLine && this.props.networkError) {
      this.props.setNetworkDrop(false);
    }
    this.validateLangRetainment();
    window.addEventListener("online", this.handleOnline.bind(this));
    window.addEventListener("offline", this.handleOffline.bind(this));
  }
  handleMenuClick = (e) => {
      Swal.fire({
        text: "Are you sure you want to logout?",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Logout",
        allowOutsideClick: false,
        focusConfirm: false,
        focusCancel: false,
        customClass: {
          confirmButton: 'swal-button--catch',
          cancelButton: 'swal-button--cancel',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "Logging Out...",
            showConfirmButton: false,
            allowOutsideClick: false,
            timer: 2000,
            timerProgressBar: true,})
          let keysToRemove = [
            "subscription",
            "persist:root",
            "rzp_device_id",
            "isLoggedIn",
            "gender",
            "patient_id",
            "patient_user_type",
            "patient_gender",
            "phiReducer",
            "patient_type",
            "is_completed",
            "setGuestUUID"
          ];
          for (let key of keysToRemove) {
            localStorage.removeItem(key);
          }
          message.destroy();
          this.props.logout();
          // if (
          //   process.env.REACT_APP_ENV != "dev" &&
          //   process.env.REACT_APP_ENV != "test"
          // )
            // window.location.href = "https://www.niyama.ai/";
        } else {
          this.setState((prevState) => ({
            selectedPath: prevState.selectedPath,
          }));
        }
      });
  };
  render() {

    const logOutDropDown= [
      // {
      //   key: '4',
      //   label: (
      //     <div className="logout-dropdown" ><img src={icons.my_profile_header} />&nbsp;{this.props.location.pathname == "/logged-in-user/my-account"
      //     ? utils.FormatName(
      //         utils.getDisplayName(
      //           this.props?.account_details?.name,
      //           this.props?.account_details?.last_name
      //         )
      //       )
      //     : utils.FormatName(
      //         utils.getDisplayName(
      //           this.props?.user_details?.name,
      //           this.props?.user_details?.last_name
      //         )
      //       )
      //   }</div>
      //   ),
      // },
      {
        key: '3',
        label: (
          <div className="logout-dropdown" onClick={this.handleMenuClick.bind(this)}><img src={icons. logout_icon}/>&nbsp;Logout</div>
        ),
      },
    ];

        let { baseUrl, routes } = this.getRoutes();
    this._routesPath = this._routesPath.filter((m) =>
      m?.key?.includes(baseUrl)
    );
    this.prepareRoutesView(routes);
    if(this.props.isMultipleRolePresent){
      this._routesPath.push(
      <Route
        path={`/role-types${ROLE_ROUTES[0].path}`}
        render={(props) => ROLE_ROUTES[0].render(props)}
        key={`/role-types${ROLE_ROUTES[0].path}-key-added`}
      ></Route>
    );}
    let options = ["Log Out"];
    if (this.state.account_details?.is_multiple_account) {
      if (
        this.state.account_details?.user_id ==
          this.state.user_details?.user_id ||
        this.state.selectedPath == "profile-lists" ||
        this.state.user_details?.role == "doctor"
      )
      options.unshift("Settings");
      options.unshift("Switch Account");
    }
    if (this.state.user_details?.role == "doctor") options.unshift("Settings");
    // const tgtLang = this.props.user_details.includePrimeLang
    //   ? this.props.i18n.language + "_" + PRIMARY_LANG
    //   : this.props.i18n.language;

    return (
      <Layout>
        {/* <Layout className="side-menu-layout"> */}
        {this.state.selectedPath == "privacy-policy" ||
        this.state.selectedPath == "terms-of-use" ||
        (this.state.selectedPath == "login" && this.state?.role && this.state.role != "care-admin")|| this.props.location.pathname == "/role-types/select-role" ||
        this.state.role == "Guest" || !this.props.isRoleSelected ? (
          <></>
        ) : (
          <Sider
          className={this.props.user_details?.org_name && this.props.location.pathname != "/logged-in-user/profile-lists" && this.props.user_details.role == "patient" && "org-color"}
            collapsible={location.pathname.includes("/video-consultation")?false:true}
            collapsed={location.pathname.includes("/video-consultation")?true:this.state.collapse}
            breakpoint={"lg"}
            theme="dark"
            onCollapse={(value) => {
              this.setState({ collapse: value });
              this.props.setCollapseValue(value);
            }}
            style={{
              overflow: "auto",
              height: "100vh",
              position: "sticky",
              top: 0,
              left: 0,
              background: "#fcfcfd",
              borderRight: "2px solid #EAECF0",
            }}
            // className={`side-menu-layout-container ${this.getSidebarStatus()}`}
          >
            <div
              className={location.pathname.includes("/video-consultation")?"n-logo2":"n-logo"}
              style={{ position: "sticky", top: 0, zIndex: 1, background: "#fcfcfd", }}
            >
              <div
                style={{
                  height: 32,
                  display: "flex",
                  alignItems: "initial",
                }}
                className={this.state.collapse?"":"niyama-new-logo"}
              >
                <img
                  src={
                    this.state.collapse || location.pathname.includes("/video-consultation")
                      ? this.state.organisation_mini_logo
                      : this.state.organisation_company_logo
                  }
                />
              </div>
            </div>
            <Menu
              mode="inline"
              inlineCollapsed
              // expandIcon={<div></div>}
              // className="side-menu-layout"
              // disabled={this.state.selectedPath == "coupon-apply"}
              // selectedKeys={[this.state.selectedPath]}
              openKeys={this.state.openKeys}
              onOpenChange={this.onOpenChange.bind(this)}
              selectedKeys={(this.props?.location?.state?.from != 'assessment-completion') ? [this.props.recent_path_route] : []}
              onSelect={(e) => {
                if (e.key == "logout") {
                  Swal.fire({
                    text: "Are you sure you want to logout?",
                    className: "heading",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    confirmButtonText: "Logout",
                    allowOutsideClick: false,
                    focusConfirm: false,
                    focusCancel: false,
                    customClass: {
                      confirmButton: 'swal-button--catch',
                      cancelButton: 'swal-button--cancel',
                    },
                  }).then((result) => {
                    if (result.isConfirmed) {
                      Swal.fire({
                        text: "Logging Out...",
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        timer: 2000,
                        timerProgressBar: true,})
                      let keysToRemove = [
                        "subscription",
                        "persist:root",
                        "rzp_device_id",
                        "isLoggedIn",
                        "gender",
                        "patient_id",
                        "patient_user_type",
                        "patient_gender",
                        "phiReducer",
                        "patient_type",
                        "is_completed",
                        "setGuestUUID"
                      ];
                      for (let key of keysToRemove) {
                        localStorage.removeItem(key);
                      }
                      this.props.logout();
                      message.destroy();
                      // if (
                      //   process.env.REACT_APP_ENV != "dev" &&
                      //   process.env.REACT_APP_ENV != "test"
                      // )
                      //   window.location.href = "https://www.niyama.ai/";
                    } else {
                      this.setState((prevState) => ({
                        selectedPath: prevState.selectedPath,
                      }));
                    }
                  });
                } else {
                  this.setState({
                    selectedPath: e.key,
                  });
                }
                this.props.removeFilteredValue("All")
                this.props.removeFilteredCouponValue("")
              }}
              onClick={this.onOpenChange.bind(this)}
              theme="dark"
              items={this.prepareRoutes(this.state.routes)}
            ></Menu>
          </Sider>
        )}
        <Layout
          className={`page-layout ${
            this.state.role == "Guest" && "signup-scrollbar-hidden"
          }`}
        >
          {this.state.showNetworkBar && (
            <div
              className={
                this.state.isOnline ? "back-online-alert" : "offline-alert"
              }
            >
              <span>{this.state.isOnline ? ONLINE_MSG : OFFLINE_MSG}</span>
            </div>
          )}
         { !location.pathname.includes("/video-consultation")&&(<div className="top-color-shaded-content">
         {/* {this.props.location.pathname != "/logged-in-user/profile-lists" && ( */}
            <Affix offsetTop={1}>
              <Header className={this.state.role == "Guest" ? "layout-header": "layout-header layout-header-label" }>
                <div className="header-detail">
                  {PUBLIC_ROUTES.includes(this.props.location.pathname) ||
                  this.state.role == "Guest" ? (
                    <>
                      <img
                        src={this.state.organisation_company_logo}
                      />
                      {GUEST_ROUTES.includes(this.props.location.pathname) && (
                        <Button
                          className="user-menu-button"
                          onClick={this.redirectToLogin.bind(this)}
                          style={{ margin: "0px 10px" }}
                        >
                          {CONSTANTS.LOGIN}
                        </Button>
                      )}
                    </>
                  ) : (
                    <>
                      <>
                        {this.props.location.pathname == "/role-types/select-role" && <img src={this.state.organisation_company_logo} />}
                      </>
                      <label className="header-label">
                      {this.state.user_details?.role == "patient" ? <Heading 
                      data={this.props} details={this.props.location.pathname == "/logged-in-user/my-account" ? this.props?.account_details : this.props?.user_details}/> : this.props.t(RouteFields[this.props.location.pathname.split("/")[2]], { lng: PRIMARY_LANG })}
                      </label>
                      <Space align="center">
                        {/* <div>Health Insurance</div> */}
                        {(this.props?.user_details?.logo_link || this.props.location.pathname == "/logged-in-user/my-account") && this.props.location.pathname != "/role-types/select-role" && <div style={{width:"115px", height:"auto"}}><img style={{width:"100%", marginLeft:"0px",  height:"auto"}} src={this.props.account_details.logo_link}/></div>}
                        <Dropdown
                            menu={{
                              items : logOutDropDown,
                            }}
                            placement="bottomLeft"
                            arrow                            
                            trigger={['click']}
                            onOpenChange={visible => {this.setState({toolTipEnabled:visible});}}
                          >
                        { ( this.props.location.pathname == "/logged-in-user/role-types/select-role" || this.props.location.pathname == "/role-types/select-role" || !this.state?.name) ? 
                          <Avatar className="avatar-header" icon={<UserOutlined />} />
                          : 
                          <Tooltip open={this.state.TooltipOpen && !this.state.toolTipEnabled} title={this.state.toolTipEnabled?'':(utils.FormatName((this.props.location.pathname == "/logged-in-user/my-account" || this.props.location.pathname == "/logged-in-user/profile-lists") ? utils.getDisplayName(this.props.account_details.name, this.props?.account_details.last_name) : utils.getDisplayName(this.state.name, this.props?.user_details.last_name)))} placement="left">
                          <Avatar   onMouseEnter={() => this.setState({TooltipOpen:true})}   onMouseLeave={() => this.setState({TooltipOpen:false})}
                            className="avatar-header"
                            // style={{
                            //   backgroundColor: "#656565",
                            // }}
                          >
                            {utils.FormatName(this.props.location.pathname == "/logged-in-user/my-account" ? this.props.account_details.name[0] : this.state?.name[0])}
                          </Avatar>
                          </Tooltip>
                        }
                        </Dropdown>
                      </Space>
                    </>
                  )}
                </div>
              </Header>
            </Affix>
          {/* )} */}
         </div>)}

         <div className={`${(this.props.location.pathname != "/logged-in-user/profile-lists" && this.props.location.pathname != "/role-types/select-role" && !location.pathname.includes("/video-consultation")) ? "layout-main-container" : "layout-main-container-without-header"} ${(this.state.role == "Guest" || this.props?.location?.pathname.includes("care-admin-domain")) ? "conditional-height" : ""} ${this.props.location.pathname.includes("/video-consultation")? "layout-main-container-without-header-footer" :""} `} >
         <div 
         className={(this.props.location.pathname != "/logged-in-user/profile-lists" && !location.pathname.includes("/video-consultation")) ? "layout-inner-with-header-main-container": "layout-inner-without-header-main-container"}
         >
          {/* <div className={`${this.props.location.pathname != "/guest-user/login" ? "top-2nd-content" : "top-2nd-content-hide"}`}>
            <div>
              <SubHeaderLeft data={this.props}/>
            </div>
            <div >
              <SubHeaderCenter data={this.props}/>
            </div>
            <div >
              <SubHeaderRight data={this.props}/>
            </div>

          </div> */}
         <Content
            className={ 
              (this.state.baseUrl == "/guest-user" || this.props.location.pathname == "/role-types/select-role")
                ? "login-content-container"
                : "main-content-container"
            }
            id="dashboard-root-container"
          >
              <div id="toast-container" style={{ height: "unset" }}></div>
              <UrlHistoryList baseUrls={(this.prepareRoutes(this.state.routes).map(({ value, path, label }) => ({ value, path, label })))}/>
              <React.Suspense fallback={<Loader />}>
                <Switch>
                  {this._routesPath}
                  <Redirect
                    from="/"
                    to={{
                      pathname: `${baseUrl}/${
                        (!this.props.isRoleSelected &&
                        this.state.role == "role")
                          ? "select-role" : 
                        this.state.role == "care-admin"
                          ? "care-admin-domain"
                          : this.state.user_details?.is_multiple_account && !this.state.user_details?.account_is_active && 
                            !history?.state?.state?.loadDashboard
                          ? "profile-lists"
                          : "dashboard"
                      }`,
                      state: { fromPath: this.state.selectedPath },
                    }}
                  />
                  <Route>
                    <PageNotFound />
                  </Route>
                </Switch>
              </React.Suspense>
              {this.state.role == "patient" &&
            this.state.selectedPath &&
            this.state.selectedPath != "video-consultation" &&
            this.state.selectedPath != "profile-lists" &&
            this.state.selectedPath != "terms-of-use" &&
            this.state.selectedPath != "privacy-policy" ? (
              <>
                {this.state.openPatientChat  ? (
                  <PatientChatWidgetNewVersion
                    isLiveChatOpen={this.state.isLiveChatOpen}
                    isAiBotChatOpen={this.state.isAiBotChatOpen}
                    chatDetails={this.state.chatDetails}
                    clearAiBotChatDtls={this.clearAiBotChatDetails.bind(this)}
                    clearChatDetails={this.clearChatDetails.bind(this)}
                    closeChatWindow={(e) => {
                      this.setState({openPatientChat : false})
                    }}
                  ai_support={this.state.ai_support}
                  />
                  // <PatientChatWidget
                  //   openChat={this.state.openPatientChat}
                  //   isLiveChatOpen={this.state.isLiveChatOpen}
                  //   chatDetails={this.state.chatDetails}
                  //   clearChatDetails={this.clearChatDetails.bind(this)}
                    
                  //   closeChat={(e) => {
                  //     this.props.retain_chat_data.length==0?
                  //     this.setState({
                  //       openPatientChat: false,
                  //     }):this.setState({ai_support:true})
                  //   }}
                  // ai_support={this.state.ai_support}
                  // />
                ) : (
                  <FloatButton
                    // shape="rectangle"
                    type="primary"
                    className="float-button-icon"
                    style={{
                      // right: 4, 
                      padding: "28px"
                    }}
                    icon={<img className="chat-icon" src={icons.icon_chat} />}
                    onClick={(e) => {
                      this.setState({
                        openPatientChat: true,
                      });
                    }}
                  />
                )}
              </>
            ) : null}
          </Content>
          {(this.state.role == "Guest" || this.props?.location?.pathname.includes("care-admin-domain") || this.props.location.pathname == "/role-types/select-role") ? (
            <></>
          ) : (
            <Footer className={this.state?.role == "care-admin" && "care-admin-footer"} style={{ textAlign: "center", minHeight:"45px", padding: "8px 0px", position:"absolute", bottom:"0", right:"0", width:"calc(100% - 0px)", display: "grid", justifyContent: "center", alignItems: "end" }}>
              {/* <FloatButton.BackTop /> */}
              <div style={{ fontSize: "12px"}}>
              {this.state?.role != "care-admin" && <div style={{paddingBottom:"4px"}}>In case of emergency, please contact Care Admin: +91 93******64</div>}
              <div><CopyrightOutlined />2024 {this.state.label_color_theme} .inc</div>
              </div>
            </Footer>
          )}
         </div>
         </div>

            {this.state.role == "care-admin" && this.state.selectedPatient ? (
              <div className="chat-main-wrapper care-admin">
                {this.state.selectedPatient.map((selectedPatient) => {
                  return (
                    <CareChatWidget
                      selectedPatient={selectedPatient}
                      closeChat={(selected) => {
                        let selecteChatList = (
                          this.state.selectedPatient || []
                        ).filter(
                          (m) => m.patient_identity != selected.patient_identity
                        );
                        this.setState({
                          selectedPatient: selecteChatList,
                        });
                      }}
                    />
                  );
                })}
              </div>
            ) : null}

{/* {this.state.role == "patient" && this.state.selectedPath && this.state.selectedPath != "video-consultation" && this.state.selectedPath != 'profile-lists' && this.state.selectedPath != 'terms-of-use' && this.state.selectedPath != 'privacy-policy' ? <div >
              {
                this.state.openPatientChat ? <PatientChatWidget
                  openChat={this.state.openPatientChat}
                  closeChat={e => {
                    this.setState({
                      openPatientChat: false
                    })
                  }} />
                  : <img className="chat-icon" src={icons.icon_chat} onClick={e => {
                    this.setState({
                      openPatientChat: true
                    })
                  }} />
              }
            </div> : null} */}
          {/* {this.state.role == "Guest" ? (
            <></>
          ) : (
            <Footer style={{ textAlign: "center", padding: "8px 0px" }}>
              <FloatButton.BackTop />
              <div style={{ fontSize: "12px"}}><div style={{paddingBottom:"4px"}}>In case of emergency, please contact Care Admin: +91 93******64</div>
              <div><CopyrightOutlined />2023 Niyama Healthcare.inc</div>
              </div>
            </Footer>
          )} */}

          {/* <Footer selectedPath={this.state.selectedPath} /> */}
        </Layout>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer.user_details,
    account_details: state.loginReducer.account_details,
    isRoleSelected: state.loginReducer.isRoleSelected,
    isMultipleRolePresent: state.loginReducer.isMultipleRolePresent,
    up_coming_path: state.loginReducer.upComingPath,
    recent_path_route: state.loginReducer.recentRoutes,
    selected_care_admin_domain: state.careAdminReducer.careAdminDomain,
    previousPath: state.breadCrumbReducer.previousPath,
    networkError: state.loginReducer.networkError,
    collapseMenu: state.dashboardReducer.collapseMenu,
    label_color_theme: state.dashboardReducer.label_color_theme,
    retain_chat_data: state.aiChatReducer.chatData,
    retainedAiBotChatDetails : state.aiChatReducer.aiBotChatDetails
  };
};

const mapDispatchToProps = (dispatch) => {

  return {
    // Crumbroutes:(e) => dispatch(breadCrumbroutes(e)),
    routesDelete: (e) => dispatch(breadCrumbroutesDelete(e)),
    logout: () => dispatch({ type: "USER_LOGOUT" }),
    recentRoute: (e) => dispatch(recentRoutes(e)),
    setNetworkDrop : (e) => dispatch(setNetworkDrop(e)),
    setLanguage: (e) => dispatch(setLanguage(e)),
    
    upComingPath: (e) => dispatch(upComingPath(e)),
    setCollapseValue: (e) => dispatch(setCollapse(e)),
    setLabelValue: (e) => dispatch(setLabelColorTheme(e)),
    removeFilteredValue: (e) => dispatch(removeFilteredValue(e)),
    resetFunnelingData: (e) => dispatch(resetFunnelingData()),
    removeCouponValue: (e) => dispatch(removeCouponValue(e)),
    removeFilteredCouponValue:(e)=> dispatch(removeFilteredCouponValue(e))

  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MainLayout))
);
